import React from 'react';

import { Button } from '../..';

type PersonFormActionButtonsProps = {
  isLastSection: boolean;
  isSaving: boolean;
  canSave: boolean;
  onPrimaryClick: () => void;
  onCancel: () => void;
  saveAriaLabel: string;
  continueAriaLabel: string;
  cancelAriaLabel: string;
  saveLabel?: string;
  cancelLabel?: string;
  cancelColor?: 'primary' | 'secondary';
};

const PersonFormActionButtons: React.FC<PersonFormActionButtonsProps> = ({
  isLastSection,
  isSaving,
  canSave,
  onPrimaryClick,
  onCancel,
  saveAriaLabel,
  continueAriaLabel,
  cancelAriaLabel,
  saveLabel = 'Salvar',
  cancelLabel = 'Cancelar',
  cancelColor = 'secondary',
}) => (
  <div className="bsds-display-flex bsds-width-100 bsds-pt-16 flex-col sm:flex-row gap-4 mt-24">
    <Button
      type="button"
      color="primary"
      fill="solid"
      className="bsds-width-100 bsds-sm-width-50 order-1 sm:order-2"
      loading={isLastSection ? isSaving : false}
      disabled={isLastSection ? !canSave || isSaving : isSaving}
      onClick={onPrimaryClick}
      aria-label={isLastSection ? saveAriaLabel : continueAriaLabel}
    >
      {isLastSection ? saveLabel : 'Continuar'}
    </Button>
    <Button
      type="button"
      onClick={onCancel}
      color={cancelColor}
      fill="outline"
      className="bsds-width-100 bsds-sm-width-50 order-2 sm:order-1"
      disabled={isSaving}
      aria-label={cancelAriaLabel}
    >
      {cancelLabel}
    </Button>
  </div>
);

export default PersonFormActionButtons;
